var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('leftNav',{staticClass:"leftNav"}),_vm._v(" "),_c('topBar',{ref:"tb",staticClass:"topBar",attrs:{"htmlon":_vm.htmlon}}),_vm._v(" "),_c('router-view',{ref:"phone",staticClass:"appMain"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fd77008","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/laout/laout.vue
// module id = null
// module chunks = 